import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    UIParametersObj: {
      desktopmenu: 'left',
      mobileinfobutton: true,
      mobilehelpbutton: true,
      mobilearbutton: true,
      iosarbutton: true,
      mobilefullscreenbutton: true,
      autorotate: false,
    },
    snackbarErrorMessage: '',
  },
  mutations: {
    setUIParametersObj(state, payload) {
      for (const property in payload) {
        if (property === 'desktopmenu') {
          state.UIParametersObj[property] = payload[property];
        } else {
          state.UIParametersObj[property] = (payload[property] == 'true');
        }
      }
    },
    showErrorMessage(state, payload) {
      state.snackbarErrorMessage = payload.message;
    },
  },
});
